import { siteConfig } from "@/data/siteConfig";
import { scrollToId } from "./shared";

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="bg-navy py-16 grain relative overflow-hidden">
    <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="border-b border-white/10 pb-12">
        <h2 className="max-w-4xl font-display text-3xl leading-tight text-cream sm:text-4xl lg:text-5xl">
          Building pathways to opportunity, one scholar at a time.
        </h2>
        <button
          data-testid="footer-apply-btn"
          onClick={() => scrollToId("#apply")}
          className="mt-8 bg-gold px-8 py-4 text-sm font-semibold tracking-wide text-navy transition-colors duration-300 hover:bg-cream"
        >
          {siteConfig.primaryCta}
        </button>
      </div>

      <div className="mt-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <p className="font-display text-lg text-cream">{siteConfig.orgName}</p>
          <p className="mt-2 text-xs uppercase tracking-[0.2em] text-gold/70">Founded by {siteConfig.founder}</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-cream/50 mb-4">Explore</p>
          <ul className="space-y-2">
            {siteConfig.nav.map((n) => (
              <li key={n.href}>
                <button onClick={() => scrollToId(n.href)} className="text-sm text-cream/70 hover:text-cream transition-colors">{n.label}</button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-cream/50 mb-4">Contact</p>
          <a href={`mailto:${siteConfig.contact.email}`} className="block text-sm text-cream/70 hover:text-cream transition-colors">{siteConfig.contact.email}</a>
          <p className="mt-2 text-sm text-cream/70">{siteConfig.contact.address}</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-cream/50 mb-4">Policies</p>
          <ul className="space-y-2 text-sm text-cream/70">
            <li><span className="cursor-default hover:text-cream transition-colors">Privacy Policy</span></li>
            <li><span className="cursor-default hover:text-cream transition-colors">Terms of Use</span></li>
            <li><span className="cursor-default hover:text-cream transition-colors">Accessibility</span></li>
          </ul>
        </div>
      </div>

      <p className="mt-12 border-t border-white/10 pt-8 text-xs text-cream/40">
        © {new Date().getFullYear()} {siteConfig.orgName}. All rights reserved.
      </p>
    </div>
  </footer>
);
